import React ,{Component} from 'react'
import HomeContent from '../components/homeContent'
export default class Home extends Component{
    render(){
        return(
            <>
                <HomeContent/>
            </>
        )
    }
}